// Home Page Permissions

export const HOME_INDEX = 95;
